import {galleryService} from '../services/gallery.services';

export const galleryData = (data ) => dispatch => {

    let galleryList = galleryService.getAllGallery(data);

    galleryList.then(galleryList => {
        dispatch({
            type: "GALLERY_DATA_SUCCESS",
            galleryList
        });
    });
}
export const moregalleryData = (data ) => dispatch => {

    let galleryList = galleryService.getAllGallery(data);

    galleryList.then(galleryList => {
        dispatch({
            type: "LOAD_MORE_GALLERY_DATA",
            galleryList
        });
    });
}
export const galleryDataFromStore = (state ) => dispatch => {

    dispatch({
        type:"GALLERY_DATA_FROM_STORE",
        state
    });

}

export const setType = ( gal_type ) => dispatch => {
    dispatch({
        type: "SET_TYPE",
        gal_type
    });
}

export const getType = (state) => dispatch => {
    dispatch({
        type: "GET_TYPE",
        state
    });
}

export const setItemId = ( gal_item ) => dispatch => {
    dispatch({
        type: "SET_ITEM_ID",
        gal_item
    });
}

export const getItemId = ( state ) => dispatch => {
    dispatch({
        type: "GET_ITEM_ID",
        state
    });
}

export const searchGallery = (data ) => dispatch => {

    let filteredData = data.galleryList;
    let searchvalue = data.search_text;
    if(searchvalue !== '') {
        filteredData = filteredData.filter(
            item => (item.title!== null)?(item.title.toLowerCase().search(searchvalue.toLowerCase()) >= 0):''
        )
    }

    if(data.sort === 'new') {
        filteredData.sort(function(a, b){
            return b.id-a.id
        });
    }
    else if(data.sort === 'old') {
        filteredData.sort(function(a, b){
            return a.id-b.id
        });
    }
    else if(data.sort === 'az') {
        filteredData.sort(function(a, b){
            if(a.title !== undefined && b.title !== undefined && a.title !== null && b.title !== null) {
                var nameA=a.title.toLowerCase(), nameB=b.title.toLowerCase()
                if (nameA < nameB) //sort string ascending
                    return -1
                if (nameA > nameB)
                    return 1
            }
            else
                return 0 //default return value (no sorting)
        });
    }
    else if(data.sort === 'za') {
        filteredData.sort(function(a, b){
            if(a.title !== undefined && b.title !== undefined && a.name !== null && b.title !== null) {
                var nameA=a.title.toLowerCase(), nameB=b.title.toLowerCase()
                if (nameA > nameB) //sort string ascending
                    return -1
                if (nameA < nameB)
                    return 1
            }
            else
                return 0 //default return value (no sorting)
        });
    }

    dispatch({
        type: "GALLERY_DATA_SEARCH_SUCCESS",
        filteredData : filteredData,
        searchText : data.search_text,
        sort : data.sort,
        userid : data.userid

    });
}

export const downloadFile = ( file ) => dispatch => {

    var downloaded = galleryService.downloadFile(file);
    dispatch({
        type: "DOWNLOAD_FILE",
        downloaded
    });
}
export const trackDownload = (data) => dispatch => {

    var tracked = galleryService.trackDownload(data);
    tracked.then(tracked => {
        dispatch({
            type: "TRACK_DOWNLOAD",
            tracked
        });
    });
}
export const createGallery = (data ) => dispatch => {

    let created = galleryService.saveGallery(data);

    created.then(created => {
        dispatch({
            type: "SAVE_GALLERY",
            created
        });
    });
}
export const setviewMode = ( state ) => dispatch => {
    dispatch({
        type: "SELECT_VIEWMODE",
        state
    });
}



// WEBPACK FOOTER //
// ./src/actions/gallery.js